import { render, staticRenderFns } from "./loginLogo.vue?vue&type=template&id=5436af9a"
var script = {}
import style0 from "./loginLogo.vue?vue&type=style&index=0&id=5436af9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports